import { useContext } from 'react';
import type { CmsSlotsDeliveryKeys } from '../../utils/amplience';
import { CmsSlotsContext } from './cmsSlotsContext';

export const useCmsSlotsContext = () => {
  const components = useContext(CmsSlotsContext);

  const getSlotComponent = (deliveryKey: CmsSlotsDeliveryKeys) => components?.[deliveryKey];

  return {
    getSlotComponent,
    components,
  };
};
